export class CreditDetails {
    constructor() {
        this.maximum_credit_amount = 0;
        this.payment_team = 0;
        this.is_allow_exceed=false;
    }
    // initialise(initialiser)
    // {
        
    //     const contact=new Contact();
    //     contact.telephone = initialiser.telephone ? initialiser.telephone : '';
    //     contact.phone =  initialiser.phone? initialiser.phone : '';
    //     contact.fullName=  initialiser.fullName? initialiser.fullName : '';
    //     contact.email=initialiser.email?initialiser.email:''
    //     return contact
    // }
}